import CustomerProject from "./components/CustomerProject";

export default CustomerProject;
